'use client';

import { useTranslations } from 'next-intl';
import { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { EventService } from '@/shared/lib/event-service';
import { Button } from '@/shared/ui/button';
import { Icon } from '@/shared/ui/icon';
import './back-button.scss';

type Props = ComponentPropsWithRef<typeof Button>;
export const BackButton = ({ className, ...props }: Props) => {
    const t = useTranslations();

    return (
        <Button
            variant="secondary"
            className={cn('back-button', className)}
            onClick={() => EventService.trigger('router:back')}
            {...props}
        >
            <Icon name="arrow-left" width={24} height={24} />
            {t('WORDS.BACK')}
        </Button>
    );
};
